import React from "react";
import { useParams, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { Home } from "lucide-react";
import "./MobileCategoryBreadcrumb.scss";

const MAX_DEPTH = 6;

// Recursive DFS over the nested category tree (same shape NAVIGATOR uses).
function findInTree(nodes, slug) {
  if (!nodes || !slug) return null;
  for (const cat of nodes) {
    if (cat.slug === slug) return cat;
    const found = findInTree(cat.children, slug);
    if (found) return found;
  }
  return null;
}

const MobileCategoryBreadcrumb = ({ selectedSlug, onNavigate }) => {
  const categories = useSelector((state) => state.category.categories);
  const itemsShow = useSelector((state) => state.displayProduct.itemsShow);
  const { id } = useParams();

  const resolve = (slug) => {
    if (!slug) return null;
    return (
      findInTree(categories, slug) ||
      (itemsShow?.slug === slug ? itemsShow : null)
    );
  };

  // Reflect the pill the user tapped or scroll-spy selection; fall back to the page category.
  const startSlug = selectedSlug || id;
  if (!startSlug) return null;

  // Walk up the ancestor chain from the current category via parentSlug.
  const trail = [];
  const seen = new Set();
  let node = resolve(startSlug);
  while (node && !seen.has(node.slug) && trail.length < MAX_DEPTH) {
    trail.unshift(node);
    seen.add(node.slug);
    node = node.parentSlug ? resolve(node.parentSlug) : null;
  }

  if (trail.length === 0) return null;

  return (
    <div className="mobile-category-breadcrumb-slot">
      <nav
        className="mobile-category-breadcrumb"
        dir="rtl"
        aria-label="ניווט קטגוריות"
      >
        <NavLink
          to="/"
          className="mobile-category-breadcrumb__item"
          aria-label="דף הבית"
          onClick={onNavigate}
        >
          <Home size={15} strokeWidth={2} />
        </NavLink>
        {trail.map((n, i) => {
          const isLast = i === trail.length - 1;
          return (
            <React.Fragment key={n.slug}>
              <span
                className="mobile-category-breadcrumb__sep"
                aria-hidden="true"
              >
                /
              </span>
              {isLast ? (
                <span className="mobile-category-breadcrumb__item mobile-category-breadcrumb__item--current">
                  {n.name}
                </span>
              ) : (
                <NavLink
                  to={`/category/${n.slug}`}
                  className="mobile-category-breadcrumb__item"
                  onClick={onNavigate}
                >
                  {n.name}
                </NavLink>
              )}
            </React.Fragment>
          );
        })}
      </nav>
    </div>
  );
};

export default MobileCategoryBreadcrumb;
